module.exports = __webpack_public_path__ + "static/img/land5.fa6a07d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/land5.jpg
// module id = tZyg
// module chunks = 0